import { useQuery } from "@tanstack/react-query";
import { settingsApi } from "@/lib/settings.api";

// Backs every "Réattribuer" visibility check across the app — the
// attribution_reassignment_enabled maintenance flag (2026-10-02). Short
// staleTime, not cached long: a super_admin flipping the flag should be
// reflected quickly for everyone else still looking at a detail page.
export function useAttributionReassignmentFlag() {
  return useQuery({
    queryKey: ["settings", "attribution-reassignment-status"] as const,
    queryFn: () => settingsApi.attributionReassignmentStatus().then((r) => r.data.enabled),
    staleTime: 30 * 1000,
  });
}
